import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback, ProtectedRoute } from "@/components/AuthGuards";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Studio from "@/pages/Studio";
import Catalog from "@/pages/Catalog";
import Builder from "@/pages/Builder";
import Wardrobe from "@/pages/Wardrobe";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import Sell from "@/pages/Sell";
import Stylist from "@/pages/Stylist";
import Admin from "@/pages/Admin";

const P = ({ children, admin }) => <ProtectedRoute admin={admin}>{children}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/katalog" element={<Catalog />} />
      <Route path="/marktplatz" element={<Marketplace />} />
      <Route path="/marktplatz/verkaufen" element={<P><Sell /></P>} />
      <Route path="/marktplatz/:id" element={<ListingDetail />} />
      <Route path="/studio" element={<P><Studio /></P>} />
      <Route path="/builder" element={<P><Builder /></P>} />
      <Route path="/kleiderschrank" element={<P><Wardrobe /></P>} />
      <Route path="/stylist" element={<P><Stylist /></P>} />
      <Route path="/admin" element={<P admin><Admin /></P>} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="flex min-h-screen flex-col bg-[#0A0A0B] text-[#FAF7F0]">
          <Header />
          <main className="flex-1"><AppRouter /></main>
          <Footer />
        </div>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
